/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Overview_Current_SpendInputs */

const es_billing_overview_current_spend = /** @type {(inputs: Billing_Overview_Current_SpendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gasto del mes`)
};

const en_billing_overview_current_spend = /** @type {(inputs: Billing_Overview_Current_SpendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current spend`)
};

/**
* | output |
* | --- |
* | "Current spend" |
*
* @param {Billing_Overview_Current_SpendInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_overview_current_spend = /** @type {((inputs?: Billing_Overview_Current_SpendInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Overview_Current_SpendInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_overview_current_spend(inputs)
	return en_billing_overview_current_spend(inputs)
});
export { billing_overview_current_spend as "billing.overview.current_spend" }